var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotteryAndDiscount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.814 3.01639L15.6618 6.74252C15.9138 7.26121 16.5857 7.75874 17.1526 7.85401L20.5018 8.41504C22.6435 8.77495 23.1475 10.3416 21.6042 11.8871L19.0004 14.5123C18.5595 14.9569 18.318 15.8144 18.4545 16.4283L19.1999 19.6781C19.7879 22.2504 18.4335 23.2455 16.1763 21.9011L13.0371 20.0274C12.4702 19.6887 11.5358 19.6887 10.9583 20.0274L7.81918 21.9011C5.57243 23.2455 4.20758 22.2398 4.79551 19.6781L5.54093 16.4283C5.67742 15.8144 5.43594 14.9569 4.99499 14.5123L2.39128 11.8871C0.85845 10.3416 1.3519 8.77495 3.49366 8.41504L6.84279 7.85401C7.39923 7.75874 8.07115 7.26121 8.32312 6.74252L10.1709 3.01639C11.1788 0.994538 12.8166 0.994538 13.814 3.01639Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotteryAndDiscount);
export default __webpack_public_path__ + "static/media/lottery_and_discount.8106086a58c2ac961f5d0f5fa85b9811.svg";
export { ForwardRef as ReactComponent };